import getStaticFile from '@helpers/bucket';

const LIGHT_THEME_PATH = 'icons/lightTheme/general';
const DARK_THEME_PATH = 'icons/darkTheme/general';

const icon = (path: string, fileName: string) => getStaticFile({ path, fileName });

export const ReputationDeliverySuccess = {
  alt: 'Entrega sem atraso',
  light: {
    src: icon(LIGHT_THEME_PATH, 'reputation-delivery-success.svg'),
    height: 24,
    width: 24,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'reputation-delivery-success.svg'),
    height: 24,
    width: 24,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'reputation-delivery-success.svg'),
    height: 24,
    width: 24,
  },
};

export const ReputationDeliveryWarning = {
  alt: 'Entrega as vezes com atraso',
  light: {
    src: icon(LIGHT_THEME_PATH, 'reputation-delivery-warning.svg'),
    height: 24,
    width: 24,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'reputation-delivery-warning.svg'),
    height: 24,
    width: 24,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'reputation-delivery-warning.svg'),
    height: 24,
    width: 24,
  },
};

export const ReputationDeliveryDanger = {
  alt: 'Entrega frequentemente com atraso',
  light: {
    src: icon(LIGHT_THEME_PATH, 'reputation-delivery-danger.svg'),
    height: 24,
    width: 24,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'reputation-delivery-danger.svg'),
    height: 24,
    width: 24,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'reputation-delivery-danger.svg'),
    height: 24,
    width: 24,
  },
};

export const ReputationServiceSuccess = {
  alt: 'Um ótimo atendimento',
  light: {
    src: icon(LIGHT_THEME_PATH, 'reputation-service-success.svg'),
    height: 24,
    width: 24,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'reputation-service-success.svg'),
    height: 24,
    width: 24,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'reputation-service-success.svg'),
    height: 24,
    width: 24,
  },
};

export const ReputationServiceWarning = {
  alt: 'Um médio atendimento',
  light: {
    src: icon(LIGHT_THEME_PATH, 'reputation-service-warning.svg'),
    height: 24,
    width: 24,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'reputation-service-warning.svg'),
    height: 24,
    width: 24,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'reputation-service-warning.svg'),
    height: 24,
    width: 24,
  },
};

export const ReputationServiceDanger = {
  alt: 'Um mau atendimento',
  light: {
    src: icon(LIGHT_THEME_PATH, 'reputation-service-danger.svg'),
    height: 24,
    width: 24,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'reputation-service-success.svg'),
    height: 24,
    width: 24,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'reputation-service-success.svg'),
    height: 24,
    width: 24,
  },
};

export const ReputationInsufficientSalesIcon = {
  alt: 'Vendas insuficientes para avaliar',
  light: {
    src: icon(LIGHT_THEME_PATH, 'reputation-insufficient-sales.svg'),
    height: 48,
    width: 48,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'reputation-insufficient-sales.svg'),
    height: 48,
    width: 48,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'reputation-insufficient-sales.svg'),
    height: 48,
    width: 48,
  },
};

export const EmptyCart = {
  alt: 'Carrinho Vazio',
  light: {
    src: icon(LIGHT_THEME_PATH, 'empty-cart.svg'),
    height: 24,
    width: 24,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'empty-cart.svg'),
    height: 24,
    width: 24,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'empty-cart.svg'),
    height: 24,
    width: 24,
  },
};

export const ExtractIcon = {
  alt: 'Carteira Vazia',
  light: {
    src: icon(LIGHT_THEME_PATH, 'extract-icon.svg'),
    height: 24,
    width: 24,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'extract-icon.svg'),
    height: 24,
    width: 24,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'extract-icon.svg'),
    height: 24,
    width: 24,
  },
};
